// Match the server's immutable delegation, independently of parcel handling.
export const orderAcceptanceMode = (line) => {
  const acceptance = line?.dropshippingIn?.paymentAcceptance;
  return acceptance?.acceptanceMode === "provider" && acceptance.providerPermission === true ? "provider" : "seller";
};
export const sellerAcceptsPayment = (line) => !line?.dropshippingIn || orderAcceptanceMode(line) === "seller";
